<template>
	<div
		v-if="$route.meta.hideSplash"
		class="mui-col-md-6 mui-col-md-offset-3 mui-panel panel"
	>
		<router-view :key="$route.fullPath"/>
	</div>

	<div v-else>
		<div class="site-info mui-col-md-7">
			<div class="heading" v-html="heading"></div>
			<div class="body" v-html="body"></div>
		</div>
		<div class="mui-col-md-1" style="min-height: 15px;"></div> <!-- dummy element for spacing -->
		<div class="login-form mui-col-md-4 mui-panel panel">
			<router-view :key="$route.fullPath"/>
		</div>
	</div>
</template>

<script>
export default {
	name: "App",
	data() {
		return {
			heading: decodeURIComponent($rec.site.heading),
			body: decodeURIComponent($rec.site.body)
		};
	}
};
</script>

<style scoped>
.site-info {
	padding: 0;
}
</style>
